import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge our token names so `text-body` (a size) and `text-fg` (a colour)
// don't cancel each other out.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['body', 'figure', 'label'],
      spacing: ['control', 'control-sm', 'control-lg', 'touch', 'control-x', 'row'],
    },
  },
});

/** Joins class names and resolves Tailwind conflicts (last one wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Visible focus ring for interactive elements (keyboard only). `outline-solid` is required:
 * in Tailwind 4, `outline-none` sets `--tw-outline-style: none`, which `outline-2` would
 * otherwise inherit, leaving an invisible ring.
 */
export const focusRing =
  'outline-none focus-visible:outline-2 focus-visible:outline-solid focus-visible:outline-offset-2 focus-visible:outline-focus-ring';

/** The same ring, always on: for "focused" specimens in the /design gallery. */
export const focusRingForced = 'outline-2 outline-solid outline-offset-2 outline-focus-ring';
